// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__vZuQU","link":"Menu_link__6xsBG","active":"Menu_active__ONYH7"};